import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import useCompressImageConfig from "../../../components/CommonApis/Compressimageapi";

function LanguageAddUpdate({ isModal = false, onSuccess, forceCreate = false }) {

    const baseURL = process.env.REACT_APP_Baseurl
    const editApi = `${baseURL}/admin/language/edit`
    const storeApi = `${baseURL}/admin/language/store`
    const updateApi = `${baseURL}/admin/language/update`
    const labelApi = `${baseURL}/admin/Label-Management/list-source`

    const { fetchRequest, globalImageUplaodAPI } = useMyContext()
    const imageApi = globalImageUplaodAPI()
    const { compressResolutionFormat } = useCompressImageConfig();
    const disableRatioValidation = Number(compressResolutionFormat?.disable_image_ratio_validation) === 1;
    const navigate = useNavigate()
    const { id } = useParams()
    const isEditing = !!id && !forceCreate
    const combinedRef = useRef({});
    const [formDataError, setFormDataError] = useState({})
    const [formData, setFormData] = useState({ name: "", slug: "", url: "site_url", in_menu: 0, in_side_menu: 0, custom_url: "", select_url: "", parent_id: 0, type: "", });
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [loading, setLoading] = useState(false);
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [darkImageFile, setDarkImageFile] = useState('');
    const [customFieldValues, setCustomFieldValues] = useState({});

    const formValidation = () => {
        let formIsValid = true;
        if (
            !formData?.name ||
            formData.name.trim().length < 3 ||
            formData.name.trim().length > 100
        ) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: !formData?.name
                    ? "Name cannot be empty."
                    : formData.name.trim().length < 3
                        ? "Name must be at least 3 characters."
                        : "Name must not exceed 100 characters.",
            }));
            combinedRef.current['name']?.focus();
            formIsValid = false;
        }


        if (
            !formData?.slug ||
            formData.slug.trim().length < 2 ||
            formData.slug.trim().length > 100 ||
            formData.slug.startsWith('-') ||
            formData.slug.endsWith('-')
        ) {
            let slugError = "";
            if (!formData?.slug) {
                slugError = "Slug cannot be empty.";
            } else if (formData.slug.trim().length < 2) {
                slugError = "Slug must be at least 2 characters.";
            } else if (formData.slug.trim().length > 100) {
                slugError = "Slug must not exceed 100 characters.";
            } else if (formData.slug.startsWith('-') || formData.slug.endsWith('-')) {
                slugError = "Slug cannot start or end with a hyphen (-).";
            }
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: slugError,
            }));
            combinedRef.current['slug']?.focus();
            formIsValid = false;
        }

        if (formDataError?.dark) {
            combinedRef.current['dark_mode_image'].focus()
            formIsValid = false;
        }
        return formIsValid;
    }

    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const expectedRatioPrecision = 0.01;
                const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
                const dimensionMatch = (width === expectedWidth && height === expectedHeight);
                if (ratioMatch || dimensionMatch) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
            img.onerror = () => {
                reject(new Error('Error loading image'));
            };
        });
    };


    const handleStore = (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault()
        if (formValidation()) {
            if (!id || forceCreate) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
        else {
            console.table("validation")
        }
    }

    const handleFileUpload = async (responseId, name) => {
        try {
            const formDataAdd = new FormData();
            if (name == 'icon') {
                const imageFields = [];
                formDataAdd.append('id', responseId)
                formDataAdd.append('modelName', 'Language');
                formDataAdd.append('language_image', darkImageFile)
                imageFields.push("language_image");
                imageFields.forEach((field) => {
                    formDataAdd.append('imageFields[]', field);
                });
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${imageApi}`,
                    params: {},
                    data: formDataAdd,
                })
            }
            setDarkImageFile(null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            for (const key in formData) {
                if (["slug"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${storeApi}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                // save custom field values (strict)
                try {
                    const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
                    const cfRes = await saveCustomFieldsConditional(
                        baseURL,
                        { 'Authorization': `Bearer ${localStorage.getItem('access_token') || sessionStorage.getItem('access_token')}`, 'Content-Type': 'application/json' },
                        'language',
                        result?.id || id,
                        customFieldValues
                    );
                    if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
                } catch (e) {
                    toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                // try {
                //     const cfRes = await fetchRequest({
                //         method: 'POST',
                //         url: `${baseURL}/admin/custom-field-values`,
                //         params: {},
                //         data: { entity_type: 'language', entity_id: result?.id || id, values: {} }
                //     });
                //     if (!cfRes?.status) throw new Error(cfRes?.message || 'Failed to save additional fields');
                // } catch (e) {
                //     toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
                //     setShowOverlay(false);
                //     return;
                // }
                if (darkImageFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                setWithOutRefresh(!withOutRefresh)
                toast.success(result?.message)
                if (typeof onSuccess === 'function') {
                    onSuccess(result?.id, formData?.name);
                } else {
                    navigate("/admin-languages")
                }
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false);
        }
    }

    const handleUpdate = async () => {
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["parent_id", "order", "in_menu", "active", "in_icon", "name", "slug", "url", "type", "select_url", "custom_url", "in_side_menu", "in_menu"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${updateApi}/${id}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                // save custom field values (strict)
                try {
                    const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
                    const cfRes = await saveCustomFieldsConditional(
                        baseURL,
                        { 'Authorization': `Bearer ${localStorage.getItem('access_token') || sessionStorage.getItem('access_token')}`, 'Content-Type': 'application/json' },
                        'language',
                        id,
                        customFieldValues
                    );
                    if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
                } catch (e) {
                    toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (darkImageFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false)
        }
    }

    const handleInput = (e) => {
        const { name, type, value, checked } = e.target;
        if (type == "text") {
            let finalValue = value;
            if (name === "slug") {
                finalValue = finalValue.replace(/[\s/]/g, '-').replace(/^-+/, '');
            }
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: finalValue,
            }));
        }

        setFormDataError((prevEditUser) => ({
            ...prevEditUser,
            [name]: '',
        }));
    }

    const handleFileChange = async (event) => {
        const { files, name, slug, value, accept } = event.target
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));
        setFormDataError((prev) => ({
            ...prev,
            [slug]: "",
        }));
        const allowedTypes = disableRatioValidation
            ? ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif', 'image/svg+xml']
            : ['image/jpeg', 'image/png', 'image/jpg'];
        if (files?.length > 0) {
            const newFile = files[0];
            const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);

            if (!allowedTypes.includes(files[0]?.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: disableRatioValidation
                        ? "Invalid file type."
                        : "Only JPG, JPEG, and PNG files are allowed.",
                }));
                setDarkImageFile(null);
                combinedRef.current['dark_mode_image'].focus()
                return;
            }

            if (!disableRatioValidation) {
                const isValidSize = await validateImageRatio(newFile, 1 / 1, 1080, 1080);
                if (!isValidSize) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 1:1 Ratio or 1080x1080px.",
                    }));
                    setDarkImageFile(null);
                    combinedRef.current['dark_mode_image'].focus()
                    return;
                }
            }

            if (name == 'dark') {
                setDarkImageFile(newFile);
            }
        }
    }

    const handleClearSelectFile = (value) => {
        if (value == 'dark') {
            setDarkImageFile(null)
        }
    }

    useEffect(async () => {
        if (id && !forceCreate) {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${editApi}/${id}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setFormData((prev) => ({
                            ...prev,
                            ...response?.Languages,
                        }));
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }
    }, [withOutRefresh]);

    const labelFetch = async () => {
        try {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${labelApi}`,
                params: { source: "all-language" },
                data: {},
            }).then((res) => {
                setLabelDisplay(res?.label_management)
            })
        }
        catch (err) {
            toast.error(err?.response?.data?.message)
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        labelFetch()
    }, [])


    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <>
            {showOverlay && <Response_Processing></Response_Processing>}
            {!isModal && <AdminBackNavigation path={`/admin-languages`} text="Back" />}
            {!isModal && <AdminSaveHeader heading={isEditing ? labelDisplay?.[6]?.title : labelDisplay?.[1]?.title} saveText={isEditing ? "Update" : "Save"} saveMethod={handleStore} loading={showOverlay} />}
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={isEditing ? labelDisplay?.[6]?.title : labelDisplay?.[1]?.title} />
                        <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Enter name"} ref={(el) => (combinedRef.current.name = el)} error={formDataError?.name} minLength={3}
                            maxLengthValidation={100} />
                        <MessageLabel text={"Slug"} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="slug" value={formData?.slug} onChange={handleInput} placeHolder={"Enter slug"} ref={(el) => (combinedRef.current.slug = el)} error={formDataError?.slug} />

                        <div className="card p-3 mt-3">
                            {/* <MessageHeading text="Additional Fields" /> */}
                            {/* Custom fields */}
                            <FieldRenderer2
                                pageIdentifier={isEditing ? "language.edit" : "language.create"}
                                entityType={"language"}
                                entityId={isEditing ? id : undefined}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={isEditing ? "language.edit" : "language.create"}
                                entityType={"language"}
                                entityId={isEditing ? id : undefined}
                                onChange={setCustomFieldValues}
                            />
                        </div>
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[3]?.title} />
                        <MessageLabel text={labelDisplay?.[4]?.title} />
                        <MessageSubHeading text={labelDisplay?.[4]?.sub_title} />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={darkImageFile}
                            uploadedImage={formData?.language_image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.dark_mode_image = el)}
                            name="dark"
                            id={isEditing ? id : undefined}
                            accept="image/jpeg,image/png,image/jpg"
                            error={formDataError?.dark}
                        />
                    </Wrapper>
                </RightWrapper>
                {isModal && (
                    <AdminCustomButton id="language-submit-down" className='px-3 py-1 m-0 ms-auto' saveMethod={handleStore} saveText={isEditing ? "Update" : "Save"} />
                )}
            </FormContainer>
        </>
    );
}
export default LanguageAddUpdate;